<template>
  <section class="item-bar">
    <div class="item-bar__cont-stats">
      <div class="item-bar__cont-stats__title">{{ title }}</div>
      <div class="item-bar__cont-stats__cont-bar">
        <div
          class="item-bar__cont-stats__cont-bar__home-cont-bar"
          @click="onClickBar($event, 'homeTeam', hVal.numberValue)"
        >
          <div class="item-bar__cont-stats__cont-bar__home-cont-bar__stats">
            {{ hVal.numberValue | toFixed2 }}<span v-if="subcategory.isPercent">%</span>
          </div>
          <div class="item-bar__cont-stats__cont-bar__home-cont-bar__bar">
            <BarraLeft class="is-clickable" :postmatch="hVal.numberBarPercent" />
          </div>
        </div>
        <div
          class="item-bar__cont-stats__cont-bar__away-cont-bar"
          @click="onClickBar($event, 'visitingTeam', aVal.numberValue)"
        >
          <div class="item-bar__cont-stats__cont-bar__away-cont-bar__bar">
            <BarraRight class="is-clickable" :postmatch="aVal.numberBarPercent" />
          </div>
          <div class="item-bar__cont-stats__cont-bar__away-cont-bar__stats">
            {{ aVal.numberValue | toFixed2 }}<span v-if="subcategory.isPercent">%</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'ItemBar',
  components: {
    BarraRight: () => import('@/components/Sections/Statistics/BarraRight'),
    BarraLeft: () => import('@/components/Sections/Statistics/BarraLeft'),
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    subcategory: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      objectZeroValues: {
        numberValue: 0,
        numberBarPercent: 0,
      },
    };
  },
  computed: {
    ...mapState('nextGeneral', ['gameForAnalysis']),
    ...mapGetters('nextGeneral', ['showLiveData']),
    hVal() {
      return this.getTeamValue(this.subcategory, this.gameForAnalysis, 'homeTeam');
    },
    aVal() {
      return this.getTeamValue(this.subcategory, this.gameForAnalysis, 'visitingTeam');
    },
  },
  methods: {
    onClickBar($event, stringTeamType, numberValue = 0) {
      this.$emit('click-bar', {
        objectEventClick: $event,
        stringTeamType,
        numberValue: numberValue,
      });
    },
    getTeamValue(objectSubcategory, objectGameForAnalysis, stringTeamType) {
      if (!objectGameForAnalysis.game_id) {
        return this.objectZeroValues;
      }
      const booleanIsPossession = objectSubcategory.generalCategoriesIds.accomplished === 3;
      if (objectGameForAnalysis.is_live && this.showLiveData) {
        const numberTeamsTotal =
          objectSubcategory.homeTeam.accomplished.totalLive + objectSubcategory.visitingTeam.accomplished.totalLive;
        return numberTeamsTotal
          ? {
              numberValue: booleanIsPossession
                ? (objectSubcategory[stringTeamType].accomplished.totalLive / numberTeamsTotal) * 100
                : objectSubcategory[stringTeamType].accomplished.totalLive,
              numberBarPercent: objectSubcategory[stringTeamType].accomplished.totalLive / numberTeamsTotal,
            }
          : this.objectZeroValues;
      } else if (objectGameForAnalysis.is_live || objectGameForAnalysis.game_status === 1) {
        const numberTeamsTotal =
          objectSubcategory.homeTeam.accomplished.totalPostGame +
          objectSubcategory.visitingTeam.accomplished.totalPostGame;
        return numberTeamsTotal
          ? {
              numberValue: booleanIsPossession
                ? (objectSubcategory[stringTeamType].accomplished.totalPostGame / numberTeamsTotal) * 100
                : objectSubcategory[stringTeamType].accomplished.totalPostGame,
              numberBarPercent: objectSubcategory[stringTeamType].accomplished.totalPostGame / numberTeamsTotal,
            }
          : this.objectZeroValues;
      }
      if (booleanIsPossession) {
        const numberValue = objectSubcategory[stringTeamType].accomplished.avgPreGame;
        return objectSubcategory[stringTeamType].accomplished.avgPostGame
          ? {
              numberValue: numberValue < 1 ? numberValue * 100 : numberValue,
              numberBarPercent: objectSubcategory[stringTeamType].accomplished.avgPreGame,
            }
          : this.objectZeroValues;
      } else {
        return objectSubcategory[stringTeamType].accomplished.leader.points
          ? {
              numberValue: objectSubcategory[stringTeamType].accomplished.avgPostGame,
              numberBarPercent:
                objectSubcategory[stringTeamType].accomplished.avgPostGame /
                objectSubcategory[stringTeamType].accomplished.leader.points,
            }
          : this.objectZeroValues;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.item-bar {
  width: 100%;
  height: auto;
  &__cont-stats {
    width: 1000px;
    height: 50px;
    // background: cyan;
    margin: 0 auto;
    @media screen and (max-width: 1140px) {
      width: 94%;
    }
    &__title {
      width: 100%;
      height: 22px;
      font-family: 'Avenir-Demi';
      // background: goldenrod;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 22px;
      letter-spacing: normal;
      text-align: center;
      color: #5a5d61;
      @media screen and (max-width: 740px) {
        font-size: 14px;
        line-height: 40px;
      }
    }
    &__cont-bar {
      width: 100%;
      height: 28px;
      // background: rgb(160, 3, 68);
      display: inline-flex;
      justify-content: space-between;
      align-content: center;
      align-items: center;
      &__home-cont-bar {
        width: 497px;
        height: 28px;
        // background: #5a5d61;
        display: inline-flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        @media screen and (max-width: 1140px) {
          width: 49.3%;
        }
        &__stats {
          width: 68px;
          // background: magenta;
          height: 28px;
          font-size: 19px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 28px;
          letter-spacing: normal;

          text-align: right;
          font-family: 'Avenir-Demi';
          color: #29455e;
          @media screen and (max-width: 940px) {
            font-size: 17px;
            line-height: 30px;
          }
          @media screen and (max-width: 740px) {
            font-size: 15px;
            line-height: 32px;
          }
          @media screen and (max-width: 640px) {
            line-height: 34px;
          }
          @media screen and (max-width: 540px) {
            font-size: 13px;
            line-height: 36px;
          }
          @media screen and (max-width: 440px) {
            font-size: 12px;
            line-height: 38px;
          }
        }
        &__bar {
          width: 429px;
          height: 28px;
          // background: pink;
          display: inline-flex;
          justify-content: space-between;
          align-content: center;
          align-items: center;
        }
      }
      &__away-cont-bar {
        width: 497px;
        height: 20px;
        // background: #5a5d61;
        display: inline-flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        @media screen and (max-width: 1140px) {
          width: 49.3%;
        }
        &__stats {
          width: 68px;
          // background: magenta;
          height: 28px;
          font-size: 19px;
          font-weight: normal;

          font-stretch: normal;
          font-style: normal;
          line-height: 28px;
          letter-spacing: normal;
          font-family: 'Avenir-Demi';
          text-align: left;
          padding-left: 5px;
          color: #29455e;
          @media screen and (max-width: 940px) {
            font-size: 17px;
            line-height: 30px;
          }
          @media screen and (max-width: 740px) {
            font-size: 15px;
            line-height: 32px;
          }
          @media screen and (max-width: 640px) {
            line-height: 34px;
          }
          @media screen and (max-width: 540px) {
            font-size: 13px;
            line-height: 36px;
          }
          @media screen and (max-width: 440px) {
            font-size: 12px;
            line-height: 38px;
          }
        }
        &__bar {
          width: 429px;
          height: 28px;
          // background: pink;
          display: inline-flex;
          justify-content: space-between;
          align-content: center;
          align-items: center;
        }
      }
    }
  }
}
</style>
